import React from "react";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {t} from "../IntManager";

export default class NotFound extends SeoComponent {
    componentWillMount() {
        super.componentWillMount();
        const { staticContext } = this.props;
        if (staticContext) {
            staticContext.is404 = true;
        }

        this.setMetaTags('Not found');
    }


    render() {
        return <LayoutComponent routerMatch={this.props.match} disableLanguageRedirect={true}>
            <div className="page__not-found u-absolute u-align-center u-fit u-pos-tl ui-light">
                <h1 className="page__not-found__title">{t('not_found')}</h1>
                <p className="page__not-found__text">{t('not_found_desc')}</p>
            </div>
            <div className="nav__footer u-absolute">
                <div className="nav__socials hide-phone">
                    <a href="//www.instagram.com/zaryadye_gastrocenter/"
                       className="nav__soc-item u-inline-block u-relative nav__soc-item_instagram" target="_blank"
                       rel="noopener noreferrer"/>
                    <a href="//www.facebook.com/zaryadyegastrocenter/"
                       className="nav__soc-item u-inline-block u-relative nav__soc-item_facebook" target="_blank"
                       rel="noopener noreferrer"/>
                </div>
            </div>
        </LayoutComponent>;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/NotFound.js